import { Skeleton } from '@mui/material'

export default function Table() {
  return (
    <Skeleton animation="wave" variant="rounded" width={'100%'} height={'60svh'} />
  )
}
